const BankidAvtaleTerm = `
#title2 Avtalevilkår for BankID
#title3 1. Kontaktinformasjon til utsteder
Eika Gruppen AS
Parkveien 61
0201 Oslo
https://www.eika.no/eika-alliansen/eikagruppen

For sperring av BankID eller andre spørsmål om sertifikater, ta kontakt med utstedende bank på e-post eller telefon, eller Eika Servicesenter
direkte på: +47 915 03 850.

#title3 2. Om avtalen
Denne avtalen inneholder vilkårene mellom deg og banken din. De forklarer hva BankID er og dine plikter som BankID-bruker. Les avtalen
nøye, og ta kontakt med banken din om det er noe du lurer på.

BankID er en felles løsning som driftes av banknæringen i Norge. En BankID utstedt av én bank, kan brukes hos andre banker og nettsteder
fordi felles regler ligger til grunn. For at BankID skal være en trygg løsning, er det viktig at du holder din BankID personlig, beskytter
utstyret og passordet du har for å benytte BankID, og sier fra til banken din hvis du er usikker på om andre kan ha fått tilgang til din
BankID. Se punktet "Oppbevaring, sikkerhet og sperring av BankID".

Banken din kan kreve at du har et kundeforhold i banken for å utstede BankID til deg.

#title3 3. Kort beskrivelse av tjenesten
BankID er en elektronisk legitimasjon og signeringsløsning som utstedes til deg av banken din. Du kan benytte BankID hos norske banker, til
å legitimere deg på offentlige og private nettsteder og signere avtaler digitalt på nettet.

BankID benyttes ved hjelp av en app, kodebrikke, et fast passord og ditt fødselsnummer. BankID kan også benyttes som app på
smarttelefonen din, hvor du benytter tastelås eller biometri til å bekrefte en innlogging eller signering, i tillegg til ditt faste passord der dette
kreves.

#title3 4. Oppbevaring, sikkerhet og sperring av BankID
#title4 4.1 Plikter til hvordan beskytte din BankID
For å beskytte din BankID mot misbruk, skal du ta alle rimelige forholdsregler for å beskytte dine passord, koder, kodebrikke, mobilen og
andre digitale enheter du har for å benytte BankID. Dette betyr for eksempel at du:
- ikke må gi fra deg BankID-passordet eller engangskoder til noen, heller ikke familiemedlemmer, verger, banken, BankID eller politiet. Du må
herunder ta alle rimelige forholdsregler for at ingen andre kan se ditt BankID-passord eller engangskoder når du taster det inn.
- må oppbevare kodebrikken din på et egnet sted, slik at den ikke ligger åpent tilgjengelig. Hvis du har med deg kodebrikken utenfor hjemmet,
må du sørge for at den ikke er tilgjengelig for andre.
- må velge et sterkt passord som ikke brukes andre steder. Du finner råd om hvordan lage sterke passord på nettvett.no. Bytt passord hvis du
er usikker på om andre kan passordet ditt.
- må huske BankID-passordet ditt. Om du likevel må skrive ned passordet ditt, skal det gjøres på en slik måte at ingen andre enn deg kan
forstå hva passordet er til. Passordet skal ikke legges sammen med kodebrikken eller annet utstyr og enheter.
- må bruke sunn skepsis når du benytter BankID-passord eller koder, særlig hvis du mottar lenker på e-post, tekstmelding eller sosiale medier
som krever at du taster inn BankID-passord og koder. Ikke skriv inn BankID-passordet ditt eller koder dersom du er usikker på nettsiden
eller om avsender av lenke virkelig er den som den utgir seg for å være.

Husk at du aldri, verken muntlig eller skriftlig, for eksempel over telefon, e-post eller på tekstmelding, skal oppgi BankID-passord eller
engangskoder. Dette gjelder også overfor noen som utgir seg for å være for eksempel banken din, BankID eller politiet.

#title4 4.2 Varsel til banken ved tap eller mistanke om tap av BankID
Du skal straks varsle banken hvis du blir oppmerksom på eller får mistanke om at:
- andre, inkludert ektefelle/partner eller andre familiemedlemmer, vet BankID-passordet ditt
- du har mistet kodebrikken din
- du har blitt frastjålet kodebrikken din
- du har mistet eller har blitt frastjålet mobilen din eller annet utstyr du har for å benytte BankID, slik at banken kan undersøke om din BankID
har blitt misbrukt
- noen har misbrukt BankID-en din

Du vil ikke bli belastet for bankens kostnader ved utstedelse av ny BankID etter melding om tap med mindre det foreligger spesielle forhold på
din side, f.eks. gjentatte meldinger om tap. på din side, f.eks. gjentatte meldinger om tap.

#title3 5. Bankens sikkerhet og sperring av BankID
#title4 5.1 Sperring ved tap eller mistanke om tap av BankID
Ved melding om tap fra deg, skal banken:
- straks sperre din BankID, og
- skriftlig bekrefte overfor deg at meldingen er mottatt og at BankID-en din er sperret.

#title4 5.2 Bankens sperring
Banken din kan på eget initiativ sperre BankID, når banken har rimelig grunn til å tro at:
- andre enn deg kan benytte BankID-en din.
- du ikke har overholdt denne avtalen.
- du ikke vil klare å overholde denne avtalen.

Ved eventuell sperring fra bankens side skal banken varsle deg og opplyse om grunnen til sperring og hvordan du eventuelt kan få sperringen
opphevet.

#title3 6. Ansvar
#title4 6.1 Ansvar generelt
Hvis du uaktsomt eller forsettlig bryter vilkårene i denne avtalen, kan du være ansvarlig for tap som påføres banken din eller andre, herunder
finansforetak og andre BankID-brukersteder.

Hvis banken uaktsomt eller forsettlig bryter vilkårene i denne avtalen, kan banken være ansvarlig for tap som påføres deg, med mindre du har
opptrådt svikaktig.

#title4 6.2 Ansvar etter finansavtaleloven
Når BankID brukes til å godkjenne betalinger eller til å signere avtaler om finansielle tjenester, vil finansavtaleloven regulere ditt og bankens
ansvar. Brudd på pliktene i denne avtalen kan også påberopes av andre ytere av finansielle tjenester, når det skal vurderes om du har ansvar
for en ikke godkjent betalingstransaksjon eller misbruk av elektronisk signatur etter finansavtaleloven.

#title3 7. Opphør av avtalen
Du kan uten forhåndsvarsel si opp avtalen om BankID. Oppsigelse sendes banken din på avtalt måte. Banken vil deretter sperre BankID-en
din.

Banken kan si opp avtalen dersom du misligholder denne avtalen, blant annet dersom du bryter plikten til å ta alle rimelige forholdsregler for å
beskytte passordene dine, koder, utstyr, mobilen og andre digitale enheter du har for å benytte BankID, og det er rimelig grunn til å tro at
tilsvarende mislighold vil skje igjen.

Oppsigelse fra banken skal ha fire ukers varsel og grunnen til oppsigelsen skal opplyses. Banken kan med øyeblikkelig virkning heve avtalen
ved vesentlig mislighold fra din side eller dersom du har opptrådt i strid med redelighet og god tro overfor banken din eller andre BankID-
brukersteder. Grunnen til hevingen skal opplyses.

Ved oppsigelse og heving kan banken sperre din BankID umiddelbart, som beskrevet i pkt. 5.2.

Banken kan også si opp avtalen uten særskilt varsel hvis kundeforhold avsluttes.

#title3 8. Priser og prisinformasjon
Pris for BankID fremgår av bankens prisliste eller opplyses på annen egnet måte.

#title3 9. Behandling av personopplysninger
Banken din er behandlingsansvarlig, og vil behandle opplysningene dine i henhold til personvernreglene (GDPR). For mer opplysninger, se
https://bankid.no/personvern-og-regler

#title3 10. Utløpte BankID‐er
Informasjon om dine utløpte og oppsagte BankID-er blir lagret i ti år etter utløpsdato. Denne informasjonen blir lagret slik at informasjonen er
tilgjengelig, selv om det skulle oppstå problemer hos din banken din.

#title3 11. Endringer i avtalen
Denne avtalen kan ved to ukers varsel endres av banken når banken har legitime grunner til slike endringer. Dette omfatter endringer i priser,
endringer på grunn av endret funksjonalitet eller endringer som kommer som følge av lov. Dersom endringen er til skade for deg, så som
prisøkning, vil banken varsle deg to måneder før endringen trer i kraft.

Dersom sikkerhetsmessige forhold gjør det nødvendig, kan Banken uten forhåndsvarsel begrense bruksområdet for BankID og foreta andre
endringer i sikkerhetsprosedyrer eller lignende. Banken skal snarest mulig etter endringen varsle deg om dette.

#title3 12. Tvisteløsning
Oppstår det tvist mellom deg og banken knyttet til denne avtalen om BankID, kan du bringe saken inn for Finansklagenemnda for uttalelse når
nemnda er kompetent i tvisten og du har saklig interesse i å få nemndas uttalelse. Banken kan bringe inn for nemnda tvist om bruk av BankID
der den er benyttet til å autentisere betalingstransaksjoner.

Dersom BankID er benyttet til å godkjenne en betalingstransaksjon som du bestrider å ha godkjent, er det egne regler i finansavtaleloven omf
hva du må gjøre og om den aktuelle bankens plikter. Nærmere informasjon om hva du bør gjøre i et slikt tilfelle kan du også finne i
kontoavtalen mellom deg og den aktuelle banken.

Henvendelser til Finansklagenemnda sendes Finansklagenemnda, Postboks 53, Skøyen 0212 Oslo, tlf. 23 13 19 60. For nærmere
informasjon se www.finkn.no.
`;

export default BankidAvtaleTerm
